<div
  id="profile-image-uploader-container"
  class="card p-4 d-flex justify-content-center"
  style="width: 100%; height: 100%"
>
  <div class="row">
    <div class="col-12">
      <h3 style="font-weight: 700; color: #060e9f">
        รูปปกศูนย์เรียนรู้<lifedi-require></lifedi-require>
      </h3>
      <nz-upload
        class="avatar-uploader"
        nzName="profile-uploader"
        nzListType="picture-card"
        [nzShowUploadList]="false"
        [nzBeforeUpload]="beforeUpload"
        [nzCustomRequest]="successRequest"
        (nzChange)="handleChange($event)"
        [(nzFileList)]="fileList"
        nzTooltipTitle="คลิกเพื่ออัปโหลดภาพปกศูนย์ย่อย"
        nzTooltipPlacement="right"
        nz-tooltip
      >
        <ng-container *ngIf="!imageUrl">
          <i
            nz-icon
            nzType="plus-circle"
            nzTheme="outline"
            style="font-size: 40px; color: #878787"
          ></i
          ><br />
          <div class="ant-upload-text">
            คลิก + เพื่ออัปโหลด ภาพปกศูนย์ย่อยของคุณ <br/> ขนาด 434x324 พิกเซล
          </div>
        </ng-container>
        <ng-container *ngIf="imageUrl" >
          <img  [src]="imageUrl" alt="profile-image" id="profile-image" style="
          max-width: 434px;
          max-height: 324px;
          width: 100%;
          height: auto;" />
        </ng-container>
     
      </nz-upload>
      <div class="row">
        <div class="col-12">
          <span>แนะนำให้ใช้รูปภาพขนาด 434x324 พิกเซล</span>
          <div id="profile-image-error-alert" *ngIf="imageProfile.invalid && (imageProfile.dirty || imageProfile.touched)"
          class="alert alert-danger">
          กรุณาอัปโหลดรูปปกศูนย์เรียนรู้
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
